
const SERVICE_URL = typeof window !== 'undefined' ? `${window.location.protocol}//${window.location.host}/` : '/';

export default SERVICE_URL;
